import React from "react";
import { Row, Col, Button, ProgressBar } from "react-bootstrap";
import { VolumeUpFill } from "react-bootstrap-icons";

export default function VocabularyForm({
  words,
  onDeleteWord,
  onPronounceWord,
  wordsSignedUrls,
}) {
  // Filtered list of words to display
  const getFilteredWords = () => {
    return words || [];
  };

  return (
    <div
      className="scrollable-container overflow-auto"
      style={{
        maxHeight: "100vh",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {/* Display the vocabulary as a list */}
      {getFilteredWords().map((item) => (
        <Row
          key={item.id}
          className="border-bottom align-items-center mx-0 py-2"
        >
          <Col xs={1} className="d-flex justify-content-center p-0">
            {/* Button to trigger pronunciation of the word */}
            <Button
              className="border-0 text-decoration-none"
              variant="outline-secondary"
              onClick={() => onPronounceWord(item.word)}
              style={{
                backgroundColor: "transparent",
                boxShadow: "none",
                color: "inherit",
              }}
            >
              <VolumeUpFill width="24" height="24" />
            </Button>
          </Col>
          <Col
            xs={1}
            className="d-flex align-items-center justify-content-center p-0"
          >
            <img
              src={wordsSignedUrls?.[item.id] || "default-image-url"}
              alt={item.word}
              style={{ width: "50px", height: "50px" }}
            />
          </Col>
          <Col xs={7}>
            <div className="d-flex flex-column p-0">
              {/* Word - original */}
              <strong className="text-primary">{item.word}</strong>
              {/* Word - translation */}
              <small>{item.translation}</small>
              {/* Word - set */}
              <small className="text-muted">
                {item.setName ? `${item.setName} Set` : ""}
              </small>
            </div>
          </Col>
          <Col xs={3} sm={1} className="d-flex p-0">
            {/* Bootstrap ProgressBar to display progress */}
            <ProgressBar
              now={item.progress || 0}
              variant={item.progress === 100 ? "success" : "info"}
              style={{
                height: "20px",
                width: "100%",
              }}
            />
          </Col>
          {onDeleteWord && (
            <Col xs={0} sm={2} className="d-flex justify-content-center p-0">
              {/* Button to delete the word from the vocabulary */}
              <Button
                variant="danger"
                size="sm"
                onClick={() => onDeleteWord(item.id)}
                style={{ padding: "2px 6px" }}
                className="d-none d-sm-inline"
              >
                Forget
              </Button>
            </Col>
          )}
        </Row>
      ))}
    </div>
  );
}
